import React from 'react';
import { motion } from 'framer-motion';

const CampaignDownloadModal = ({
  showModal,
  onClose,
  onDownloadWithoutCampaign,
  onDownloadWithCampaign,
  downloading,
  customerCount,   // null = loading, -1 = failed, number = loaded
  campaignType = 'filtered',
  campaignName
}) => {
  if (!showModal) return null;

  const countIsLoading = customerCount === null;
  const countFailed = customerCount === -1;

  const renderCount = () => {
    if (countIsLoading) {
      return (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
          <span
            style={{
              display: 'inline-block',
              width: 14,
              height: 14,
              border: '2px solid #aaa',
              borderTop: '2px solid #555',
              borderRadius: '50%',
              animation: 'spin 0.8s linear infinite'
            }}
          />
          counting...
        </span>
      );
    }
    if (countFailed) return <span style={{ color: '#c0392b' }}>could not load count</span>;
    return <strong>{customerCount.toLocaleString()}</strong>;
  };

  return (
    <div className="campaign-download-modal-overlay" onClick={onClose}>
      <motion.div
        className="campaign-download-modal"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.8 }}
        onClick={(e) => e.stopPropagation()}
      >
        <button onClick={onClose} className="close-modal-btn">×</button>
        <h3>Download Customer Data</h3>

        <p>
          {campaignName && <><strong>{campaignName}</strong> — </>}
          {campaignType === 'converted' ? 'Converted' : 'Non-converted'} customers:{' '}
          {renderCount()}
        </p>

        <p className="modal-subtitle">
          Downloads happen in the background.
        </p>

        <div className="modal-actions">
          <button
            onClick={onDownloadWithoutCampaign}
            className="download-without-campaign-btn"
            disabled={downloading}
            style={{ opacity: downloading ? 0.6 : 1, cursor: downloading ? 'not-allowed' : 'pointer' }}
          >
            {downloading ? (
              <>
                <span
                  className="loading-spinner"
                  style={{
                    display: 'inline-block',
                    width: 16,
                    height: 16,
                    border: '2px solid #ffffff',
                    borderTop: '2px solid transparent',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                    marginRight: 8
                  }}
                />
                Starting...
              </>
            ) : (
              'Download Without Campaign'
            )}
          </button>

          <button
            onClick={() => { if (onDownloadWithCampaign) onDownloadWithCampaign(); }}
            className="download-with-campaign-btn"
            disabled={downloading}
            style={{ opacity: downloading ? 0.6 : 1, cursor: downloading ? 'not-allowed' : 'pointer' }}
          >
            Download With Campaign Info
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default CampaignDownloadModal;
